<template>
    <div style="margin-top: 5%">
        <h1>扫码领红包</h1>
        <van-button class="mr" v-if="wxCode !== null" type="primary" @click="scanCode">点击扫码</van-button>
    </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import common from '@/common/Common.js'
import axios from 'axios'

export default {
  name: 'hello',
  data () {
    return {
      qrCode: this.$route.query.qrCode || null,
      wxCode: this.$route.query.code || null, // 微信code，用于授权登录
      signData: null
    }
  },
  mounted () {
    this.wxLogin()
  },
  methods: {
    // 微信登录
    wxLogin () {
      if (this.wxCode === null) {
        let locationHref = location.href
        window.location.replace('https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + common.appId + '&redirect_uri=' +
          locationHref + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect')
      }
    },
    scanCode () {
      let that = this

      axios.get(common.apiUrl + '/api/lucky/sign', {
        params: {
          url: window.location.href
        }
      }).then(function (response) {
        if (response.data.code === 0) {
          that.signData = response.data.data
          that.invokeWeChatScan()
        } else {
          that.$notify({ message: response.data.message })
        }
      })
    },
    submitQrCode () {
      let that = this
      axios({
        method: 'post',
        url: common.apiUrl + '/api/lucky/submitCode',
        data: {
          luckyCode: that.qrCode,
          wxCode: that.wxCode
        }
      }).then(function (response) {
        if (response.data.code === 0) {
          that.$notify({ message: '成功领取20元红包,请注意微信到账提示' })
        } else {
          that.$notify({ message: response.data.message })
        }
      })
    },
    invokeWeChatScan () {
      let that = this
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: that.signData.appId, // 必填，公众号的唯一标识
        timestamp: that.signData.timestamp, // 必填，生成签名的时间戳
        nonceStr: that.signData.nonceStr, // 必填，生成签名的随机串
        signature: that.signData.signature, // 必填，签名
        jsApiList: ['scanQRCode'] // 必填，需要使用的JS接口列表
      })
      wx.ready(function () {
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
          success: function (res) {
            that.qrCode = res.resultStr // 当needResult 为 1 时，扫码返回的结果
            that.submitQrCode()
          }
        })
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
    .mr {
        margin-top 30px
    }
</style>
